// src/redux/reducers/contextReducer.js

import { SET_CONTEXT_DATA, UPDATE_CONTEXT_DATA, FETCH_UNIFIED_NARRATIVE_SUCCESS,SAVE_CONTEXT_DATA_FAILURE,  FETCH_NARRATIVE_SUCCESS, FETCH_CONTEXT_DATA_START, FETCH_CONTEXT_DATA_SUCCESS, FETCH_CONTEXT_DATA_FAILURE, FETCH_NARRATIVE_START} from '../actions/actionTypes';

const initialState = {
    data: {},
    narratives: {},
    loading: false,
    error: null
};

const contextReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_CONTEXT_DATA: {
            const { modelId, data } = action.payload;
            console.log('Received in context data reducer for set', action.payload);
            
            return {
              ...state,
              data: {
                ...state.data,
                [modelId]: data
              }
            };
          }
          
          case UPDATE_CONTEXT_DATA: {
            const { modelId, section, fieldName, value } = action.payload;
            console.log('Received in context data reducer for update', action.payload);
            // Ensure data structure integrity when updating nested fields
            const modelData = state.data[modelId] || {};
            const sectionData = modelData[section] || {};
            return {
              ...state,
              data: {
                ...state.data,
                [modelId]: {
                  ...modelData,
                  [section]: {
                    ...sectionData,
                    [fieldName]: value
                  }
                }
              }
            };
          }

        
        
        case SAVE_CONTEXT_DATA_FAILURE:
                        return {
                        ...state,
                        loading: false,
                        error: action.payload
                        };

        case FETCH_NARRATIVE_START:
            return {
                ...state,
                loading: true,
                error: null
            };

            case FETCH_NARRATIVE_SUCCESS: 
                            const { modelId, section, narrative } = action.payload;
                            const modelData = state.data[modelId] || {};
                            const sectionData = modelData[section] || {};
                            console.log ('narative received in reducer', action.payload)
                            return {
                              ...state,
                              data: {
                                ...state.data,
                                [modelId]: {
                                  ...modelData,
                                  [section]: {
                                    ...sectionData,
                                    narrative:narrative
                                  }
                                }
                               
                              },
                              loading: false,
                              error: null
                            };

          case FETCH_CONTEXT_DATA_START:
            return {
                ...state,
                loading: true,
                error: null
            };
       
            case FETCH_CONTEXT_DATA_SUCCESS: {
                const { modelId, data } = action.payload;
                console.log('fetch context data in reducer:', data);
                const existingData = state.data[modelId] || {};
                // Deep-merge each section so we don't overwrite entire objects
                const mergedSections = Object.entries(data).reduce((acc, [section, value]) => {
                    const prevSection = existingData[section] || {};
                    if (value && typeof value === 'object' && !Array.isArray(value) &&
                        prevSection && typeof prevSection === 'object') {
                        acc[section] = { ...prevSection, ...value };
                    } else if (value !== null && value !== undefined) {
                        acc[section] = value;
                    } else {
                        acc[section] = prevSection;
                    }
                    return acc;
                }, { ...existingData });
                console.log('merged context data:', mergedSections);
                return {
                    ...state,
                    loading: false,
                    data: {
                        ...state.data,
                        [modelId]: mergedSections
                    },
                    error: null
                };
            }
            
        case FETCH_CONTEXT_DATA_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        case FETCH_UNIFIED_NARRATIVE_SUCCESS: {
            const { modelId, narrative, keyCharacteristics, confidence, missingInfo } = action.payload;
            const modelData = state.data[modelId] || {};
            return {
                ...state,
                data: {
                    ...state.data,
                    [modelId]: {
                        ...modelData,
                        unifiedNarrative: {
                            narrative,
                            keyCharacteristics,
                            confidence,
                            missingInfo
                        }
                    }
                },
                loading: false,
                error: null
            };
        }
                   
                        default:
                        return state;
                        }
                    };

                        
                        
                        export default contextReducer;